<template>
  <div class="app-container finance-page">
    <finance-query-panel
      title="财务异常"
      description="异常由合同金额、累计回款、累计开票和产品构成实时计算，仅作为财务核对入口，不替代会计判断。"
      :report-year.sync="reportYear"
      :query-params.sync="queryParams"
      :dashboard="dashboard"
      :loading="loading"
      @query="queryData"
      @reset="resetQuery"
    />
    <el-row :gutter="14" class="metric-row">
      <el-col v-for="item in riskCards" :key="item.label" :xs="12" :sm="6">
        <el-card shadow="never" class="metric-card">
          <div class="metric-label">{{ item.label }}</div>
          <div class="metric-value" :class="item.className">{{ item.value }}</div>
          <div class="metric-note">{{ item.note }}</div>
        </el-card>
      </el-col>
    </el-row>
    <el-alert type="warning" :closable="false" show-icon class="finance-alert">
      <template slot="title">“回款高于开票”和“开票高于回款”是业务关注项，不等同于违规；请结合合同付款和开票条件判断。</template>
    </el-alert>
    <el-card shadow="never" class="table-card">
      <div class="risk-toolbar">
        <div class="card-title">异常及关注清单</div>
        <el-select v-model="riskType" clearable placeholder="全部类型" style="width: 180px" @change="pageNum = 1">
          <el-option v-for="type in riskTypes" :key="type" :label="type" :value="type" />
        </el-select>
      </div>
      <el-table :data="pagedRisks" border stripe v-loading="loading" height="620">
        <el-table-column label="级别" width="85" align="center" fixed="left">
          <template slot-scope="scope"><el-tag :type="tagType(scope.row.level)" size="mini">{{ levelName(scope.row.level) }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="riskType" label="类型" width="130" fixed="left" />
        <el-table-column prop="contractNum" label="合同编号" min-width="145">
          <template slot-scope="scope"><el-button type="text" @click="openContract(scope.row)">{{ scope.row.contractNum }}</el-button></template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户" min-width="180" show-overflow-tooltip />
        <el-table-column prop="departmentName" label="部门" min-width="130" />
        <el-table-column prop="assignUserName" label="负责人" width="100" />
        <el-table-column label="关注金额" width="140" align="right">
          <template slot-scope="scope">{{ amount(scope.row.amount) }}</template>
        </el-table-column>
        <el-table-column prop="description" label="核对说明" min-width="300" show-overflow-tooltip />
      </el-table>
      <pagination v-show="filteredRisks.length > 0" :total="filteredRisks.length" :page.sync="pageNum" :limit.sync="pageSize" />
    </el-card>
  </div>
</template>

<script>
import FinanceQueryPanel from './components/FinanceQueryPanel'
import receivableFinanceMixin from './components/receivableFinanceMixin'
import { buildFinanceRisks } from './components/financeShared'

export default {
  name: 'FinanceRisk',
  financeScene: 'risk',
  components: { FinanceQueryPanel },
  mixins: [receivableFinanceMixin],
  data () {
    return { riskType: null, pageNum: 1, pageSize: 20 }
  },
  computed: {
    risks () { return buildFinanceRisks(this.dashboard) },
    riskTypes () { return Array.from(new Set(this.risks.map(item => item.riskType))) },
    filteredRisks () { return this.riskType ? this.risks.filter(item => item.riskType === this.riskType) : this.risks },
    pagedRisks () {
      const start = (this.pageNum - 1) * this.pageSize
      return this.filteredRisks.slice(start, start + this.pageSize)
    },
    riskCards () {
      const count = type => this.risks.filter(item => item.riskType === type).length
      const gapCount = this.risks.filter(item => ['回款高于开票', '开票高于回款'].includes(item.riskType)).length
      return [
        { label: '超额回款', value: count('超额回款'), note: '需优先复核 / 份', className: 'danger' },
        { label: '超额开票', value: count('超额开票'), note: '需优先复核 / 份', className: 'danger' },
        { label: '回款开票差额', value: gapCount, note: '业务关注 / 份', className: 'warning' },
        { label: '产品待归类', value: count('产品待归类'), note: '历史兜底 / 份', className: 'info' }
      ]
    }
  },
  watch: {
    dashboard () { this.pageNum = 1 }
  },
  methods: {
    tagType (level) { return level === 'danger' ? 'danger' : level === 'warning' ? 'warning' : 'info' },
    levelName (level) { return level === 'danger' ? '高风险' : level === 'warning' ? '关注' : '提示' }
  }
}
</script>

<style lang="scss" scoped>
.finance-page { min-height: calc(100vh - 84px); background: #f5f7fa; }
.metric-row { margin-top: 14px; }
.metric-card, .table-card { margin-bottom: 14px; }
.metric-label { color: #909399; font-size: 13px; }
.metric-value { margin-top: 10px; color: #303133; font-size: 28px; font-weight: 600; }
.metric-value.danger { color: #e85d5d; }
.metric-value.warning { color: #e6a23c; }
.metric-value.info { color: #4b86f8; }
.metric-note { margin-top: 5px; color: #a6a9ad; font-size: 12px; }
.finance-alert { margin-bottom: 14px; }
.risk-toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.card-title { color: #303133; font-size: 16px; font-weight: 600; }
</style>
